import { format } from 'date-fns'
import type { TransferListParams, TransferStatus } from '../types/transfer'
import type { TransferFilterFormValues } from '../types/transferFilterForm'

/**
 * Map UI form to GET `/api/transfer_process_log` query fields (legacy Angular `getFilterValue` parity).
 * Dates are sent as `DD-MM-YYYY` (`fromDt` / `toDt`) per Angular.
 */
export function buildTransferListParamsFromForm(
  form: TransferFilterFormValues,
  base: Pick<TransferListParams, 'perPage' | 'sortBy' | 'orderBy' | 'page'>,
): TransferListParams {
  const p: TransferListParams = {
    page: 1,
    perPage: base.perPage,
    sortBy: base.sortBy,
    orderBy: base.orderBy,
  }
  if (form.search.trim()) p.search = form.search.trim()
  if (form.org_id) p.org_id = form.org_id
  if (form.company_id) p.company_id = form.company_id
  if (form.property_id) p.property_id = form.property_id
  if (form.process_name) p.process_name = form.process_name
  if (form.fk_team_id) p.fk_team_id = form.fk_team_id
  if (form.status) p.status = form.status as TransferStatus
  if (form.dateStart && form.dateEnd) {
    p.fromDt = format(form.dateStart, 'dd-MM-yyyy')
    p.toDt = format(form.dateEnd, 'dd-MM-yyyy')
  }
  return p
}
